export const depoimentos = [
  {
    id: 1,
    nome: "Gabriela Oliveira",
    cidade: "São Paulo, SP",
    email: "gabriela@example.com",
    foto: "https://public.readdy.ai/ai/img_res/c95e030cf59a5f06b83ffec6422f5e2e.jpg",
    categoria: "Saúde",
    tipoTransformacao: "Ansiedade",
    tempoUsando: "8 meses",
    depoimento: "Sofria de ansiedade crônica há anos. Tentei terapia, medicamentos, meditação... nada funcionava completamente. Quando comecei a escrever cartas para meu eu futuro, algo mudou. Pela primeira vez, consegui visualizar um futuro sem medo. Hoje, 8 meses depois, minha ansiedade diminuiu 80%. Durmo melhor, trabalho melhor, vivo melhor. Esta prática salvou minha vida.",
    fraseDestaque: "Pela primeira vez, consegui visualizar um futuro sem medo",
    estrelas: 5,
    curtidas: 342,
    dataPublicacao: "2024-01-15"
  },
  {
    id: 2,
    nome: "Carlos Eduardo Santos",
    cidade: "Rio de Janeiro, RJ",
    email: "carlos@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20mature%20brazilian%20man%20in%20his%20forties%20genuine%20smile%20natural%20daylight%20neutral%20background%20confident%20expression%20business%20casual%20attire%20high%20quality%20photography&width=400&height=400&seq=depoimento2&orientation=squarish",
    categoria: "Saúde",
    tipoTransformacao: "Depressão",
    tempoUsando: "1 ano e 3 meses",
    depoimento: "Passei 5 anos em depressão profunda. Perdi meu emprego, meus amigos, quase perdi minha família. O Carta do Eu Futuro foi minha última tentativa antes de desistir de tudo. Escrever para mim mesmo no futuro me fez perceber que eu ainda tinha esperança, mesmo quando achava que não tinha. Hoje estou empregado novamente, reconstruí meus relacionamentos e, pela primeira vez em anos, sinto que vale a pena viver.",
    fraseDestaque: "Escrever para mim mesmo me fez perceber que eu ainda tinha esperança",
    estrelas: 5,
    curtidas: 521,
    dataPublicacao: "2024-02-20"
  },
  {
    id: 3,
    nome: "Fernanda Costa",
    cidade: "Belo Horizonte, MG",
    email: "fernanda@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20brazilian%20woman%20in%20her%20twenties%20bright%20smile%20natural%20outdoor%20lighting%20soft%20background%20joyful%20expression%20casual%20elegant%20style%20high%20quality%20photography&width=400&height=400&seq=depoimento3&orientation=squarish",
    categoria: "Saúde",
    tipoTransformacao: "Síndrome do Pânico",
    tempoUsando: "6 meses",
    depoimento: "Minha primeira crise de pânico foi no metrô. Depois disso, não conseguia mais sair de casa sem sentir que ia morrer. Perdi meu emprego, minha independência, minha vida. Uma amiga me indicou o Carta do Eu Futuro. No começo, achei bobagem. Mas comecei a escrever mesmo assim. Hoje, 6 meses depois, voltei a andar de metrô. Voltei a trabalhar. Voltei a viver. As crises ainda acontecem, mas agora eu sei que vou superar.",
    fraseDestaque: "Voltei a andar de metrô. Voltei a trabalhar. Voltei a viver",
    estrelas: 5,
    curtidas: 289,
    dataPublicacao: "2024-03-10"
  },
  {
    id: 4,
    nome: "Roberta Almeida",
    cidade: "Curitiba, PR",
    email: "roberta@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20mature%20brazilian%20woman%20in%20her%20fifties%20with%20short%20dark%20hair%20warm%20smile%20natural%20lighting%20elegant%20background%20serene%20expression%20sophisticated%20style%20high%20quality%20photography&width=400&height=400&seq=depoimento-roberta-unique&orientation=squarish",
    categoria: "Superação",
    tipoTransformacao: "Traumas",
    tempoUsando: "2 anos",
    depoimento: "Carreguei traumas de infância por 50 anos. Abuso, negligência, dor. Fiz terapia por décadas, mas sempre havia uma ferida que não cicatrizava. Quando descobri o Carta do Eu Futuro, decidi tentar mais uma vez. Escrever cartas para meu eu futuro me permitiu perdoar meu eu passado. Hoje, aos 52 anos, finalmente me sinto livre. Nunca é tarde para recomeçar.",
    fraseDestaque: "Escrever para meu eu futuro me permitiu perdoar meu eu passado",
    estrelas: 5,
    curtidas: 456,
    dataPublicacao: "2024-01-25"
  },
  {
    id: 5,
    nome: "Lucas Ferreira",
    cidade: "Porto Alegre, RS",
    email: "lucas@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20brazilian%20man%20in%20his%20twenties%20confident%20smile%20natural%20daylight%20modern%20background%20determined%20expression%20casual%20smart%20style%20high%20quality%20photography&width=400&height=400&seq=depoimento5&orientation=squarish",
    categoria: "Carreira",
    tipoTransformacao: "Carreira",
    tempoUsando: "10 meses",
    depoimento: "Estava preso em um emprego que odiava há 7 anos. Tinha medo de mudar, medo de arriscar, medo de fracassar. Comecei a escrever cartas para meu eu futuro descrevendo a carreira dos meus sonhos. Algo incrível aconteceu: comecei a tomar ações para tornar aquele futuro realidade. Hoje, 10 meses depois, larguei meu emprego tóxico, abri minha própria empresa e estou mais feliz do que nunca. O futuro que eu escrevi está se tornando real.",
    fraseDestaque: "O futuro que eu escrevi está se tornando real",
    estrelas: 5,
    curtidas: 378,
    dataPublicacao: "2024-02-05"
  },
  {
    id: 6,
    nome: "Ana Paula Costa",
    cidade: "Brasília, DF",
    email: "anapaula@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20brazilian%20woman%20in%20her%20thirties%20with%20short%20blonde%20pixie%20cut%20hair%20radiant%20smile%20natural%20lighting%20soft%20background%20confident%20expression%20elegant%20casual%20style%20high%20quality%20photography&width=400&height=400&seq=depoimento-anapaula-unique&orientation=squarish",
    categoria: "Autoestima",
    tipoTransformacao: "Amor-próprio",
    tempoUsando: "1 ano",
    depoimento: "Passei a vida inteira me odiando. Meu corpo, meu rosto, minha personalidade. Tudo em mim era errado. Desenvolvi transtornos alimentares, depressão, ansiedade. Quando comecei o Carta do Eu Futuro, mal conseguia escrever coisas positivas sobre mim. Mas continuei. Hoje, 1 ano depois, olho no espelho e vejo uma mulher forte, capaz e bonita. Aprendi a me amar. E isso mudou absolutamente tudo.",
    fraseDestaque: "Aprendi a me amar. E isso mudou absolutamente tudo",
    estrelas: 5,
    curtidas: 612,
    dataPublicacao: "2024-03-01"
  },
  {
    id: 7,
    nome: "Rafael Mendes",
    cidade: "Recife, PE",
    email: "rafael@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20brazilian%20man%20in%20his%20late%20forties%20with%20gray%20beard%20warm%20smile%20natural%20outdoor%20lighting%20neutral%20background%20peaceful%20expression%20casual%20style%20high%20quality%20photography&width=400&height=400&seq=depoimento-rafael-unique&orientation=squarish",
    categoria: "Saúde",
    tipoTransformacao: "Saúde Mental",
    tempoUsando: "9 meses",
    depoimento: "Burnout completo. Não conseguia trabalhar, não conseguia dormir, não conseguia viver. Minha mente estava destruída. Os médicos me deram remédios, mas eu precisava de algo mais. O Carta do Eu Futuro me deu esperança. Escrever sobre quem eu queria ser me ajudou a lembrar quem eu era. Hoje estou em recuperação, voltando aos poucos, mas com uma nova perspectiva sobre saúde mental e autocuidado.",
    fraseDestaque: "Escrever sobre quem eu queria ser me ajudou a lembrar quem eu era",
    estrelas: 5,
    curtidas: 234,
    dataPublicacao: "2024-02-15"
  },
  {
    id: 8,
    nome: "Juliana Rodrigues",
    cidade: "Salvador, BA",
    email: "juliana@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20brazilian%20woman%20in%20her%20late%20thirties%20with%20long%20curly%20hair%20joyful%20smile%20natural%20lighting%20colorful%20background%20vibrant%20expression%20modern%20casual%20style%20high%20quality%20photography&width=400&height=400&seq=depoimento-juliana-rodrigues&orientation=squarish",
    categoria: "Relacionamentos",
    tipoTransformacao: "Família",
    tempoUsando: "7 meses",
    depoimento: "Meu relacionamento com minha família estava destruído. Anos de mágoas, brigas e ressentimentos. Não falava com minha mãe há 3 anos. Comecei a escrever cartas para meu eu futuro imaginando uma reconciliação. Isso me deu coragem para dar o primeiro passo. Hoje, 7 meses depois, voltei a falar com minha mãe. Ainda estamos reconstruindo, mas pela primeira vez em anos, tenho esperança de ter uma família de novo.",
    fraseDestaque: "Pela primeira vez em anos, tenho esperança de ter uma família de novo",
    estrelas: 5,
    curtidas: 401,
    dataPublicacao: "2024-01-30"
  },
  {
    id: 9,
    nome: "Pedro Henrique Lima",
    cidade: "Fortaleza, CE",
    email: "pedro@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20brazilian%20man%20in%20his%20forties%20confident%20smile%20natural%20daylight%20professional%20background%20determined%20expression%20business%20casual%20style%20high%20quality%20photography&width=400&height=400&seq=depoimento9&orientation=squarish",
    categoria: "Superação",
    tipoTransformacao: "Superação",
    tempoUsando: "1 ano e 6 meses",
    depoimento: "Perdi tudo em um acidente. Minha saúde, meu emprego, minha mobilidade. Os médicos disseram que eu nunca mais andaria. Fiquei 2 anos em depressão profunda. Então descobri o Carta do Eu Futuro. Comecei a escrever sobre um futuro onde eu estava de pé novamente. Parecia impossível, mas continuei escrevendo. Hoje, 1 ano e meio depois, voltei a andar. Os médicos chamam de milagre. Eu chamo de poder da mente e da esperança.",
    fraseDestaque: "Os médicos chamam de milagre. Eu chamo de poder da mente e da esperança",
    estrelas: 5,
    curtidas: 789,
    dataPublicacao: "2024-03-05"
  },
  {
    id: 10,
    nome: "Camila Souza",
    cidade: "Manaus, AM",
    email: "camila@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20brazilian%20woman%20in%20her%20twenties%20gentle%20smile%20natural%20lighting%20soft%20background%20calm%20expression%20elegant%20casual%20style%20high%20quality%20photography&width=400&height=400&seq=depoimento10&orientation=squarish",
    categoria: "Saúde",
    tipoTransformacao: "Ansiedade Social",
    tempoUsando: "5 meses",
    depoimento: "Ansiedade social me impediu de viver por anos. Não conseguia fazer apresentações no trabalho, não conseguia conhecer pessoas novas, não conseguia nem ir ao supermercado sozinha. O Carta do Eu Futuro me ajudou a visualizar uma versão de mim mesma que era corajosa e confiante. Hoje, 5 meses depois, fiz minha primeira apresentação no trabalho. Meu coração ainda acelera, mas agora eu enfrento. E cada vitória me deixa mais forte.",
    fraseDestaque: "Cada vitória me deixa mais forte",
    estrelas: 5,
    curtidas: 267,
    dataPublicacao: "2024-02-28"
  },
  {
    id: 11,
    nome: "Thiago Barbosa",
    cidade: "Goiânia, GO",
    email: "thiago@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20brazilian%20man%20in%20his%20twenties%20bright%20smile%20natural%20outdoor%20lighting%20modern%20background%20optimistic%20expression%20casual%20style%20high%20quality%20photography&width=400&height=400&seq=depoimento11&orientation=squarish",
    categoria: "Relacionamentos",
    tipoTransformacao: "Relacionamento Amoroso",
    tempoUsando: "11 meses",
    depoimento: "Depressão pós-término de relacionamento. Achei que nunca mais seria feliz. Passei meses trancado em casa, sem vontade de viver. Uma terapeuta me indicou o Carta do Eu Futuro. No começo, não conseguia imaginar um futuro feliz. Mas forcei-me a escrever mesmo assim. Hoje, 11 meses depois, estou namorando novamente, voltei a sair com amigos e redescobri a alegria de viver. O futuro que parecia impossível está aqui.",
    fraseDestaque: "O futuro que parecia impossível está aqui",
    estrelas: 5,
    curtidas: 345,
    dataPublicacao: "2024-01-20"
  },
  {
    id: 12,
    nome: "Patrícia Martins",
    cidade: "Florianópolis, SC",
    email: "patricia@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20mature%20brazilian%20woman%20in%20her%20forties%20serene%20smile%20natural%20lighting%20elegant%20background%20peaceful%20expression%20sophisticated%20casual%20style%20high%20quality%20photography&width=400&height=400&seq=depoimento12&orientation=squarish",
    categoria: "Autoestima",
    tipoTransformacao: "Amor-próprio",
    tempoUsando: "1 ano e 2 meses",
    depoimento: "Depois de um casamento abusivo de 15 anos, não sabia mais quem eu era. Minha autoestima estava destruída. Achava que não merecia ser feliz. O Carta do Eu Futuro foi minha ferramenta de reconstrução. Escrever para meu eu futuro me ajudou a redescobrir meus sonhos, meus valores, minha essência. Hoje, mais de 1 ano depois, sou uma mulher completamente diferente. Forte, independente e, finalmente, feliz.",
    fraseDestaque: "Forte, independente e, finalmente, feliz",
    estrelas: 5,
    curtidas: 523,
    dataPublicacao: "2024-02-10"
  },
  {
    id: 13,
    nome: "Mariana Rodrigues",
    cidade: "São Paulo, SP",
    email: "mariana.r@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20confident%20executive%20brazilian%20woman%20in%20her%20thirties%20dark%20blazer%20boardroom%20background%20warm%20confident%20smile%20corporate%20lighting%20premium%20photography&width=400&height=400&seq=dep-mariana-ceo&orientation=squarish",
    categoria: "Carreira",
    tipoTransformacao: "Liderança e Negócios",
    tempoUsando: "9 meses",
    depoimento: "Era gerente de produto há 5 anos sem conseguir a promoção que merecia. Sentia que havia um teto invisible bloqueando meu crescimento — e esse teto era eu mesma. Com o método da Bia e as técnicas de PNL, identifiquei e eliminei a crença de que eu não era 'boa o suficiente'. Três meses depois de iniciar o trabalho de reprogramação, fui promovida a diretora. Meu salário triplicou. E o mais importante: hoje lidero com confiança real.",
    fraseDestaque: "O teto invisível que me bloqueava era eu mesma",
    estrelas: 5,
    curtidas: 697,
    dataPublicacao: "2024-04-12"
  },
  {
    id: 14,
    nome: "Isabela Neves",
    cidade: "Campinas, SP",
    email: "isabela@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20beautiful%20young%20brazilian%20woman%20in%20her%20late%20twenties%20warm%20brown%20eyes%20natural%20smile%20relaxed%20home%20office%20background%20soft%20bokeh%20modern%20authentic%20photography&width=400&height=400&seq=dep-isabela-neves&orientation=squarish",
    categoria: "Relacionamentos",
    tipoTransformacao: "Conexões Pessoais",
    tempoUsando: "8 meses",
    depoimento: "Sempre tive dificuldade em criar conexões genuínas. Tinha muitos conhecidos, mas nenhuma amizade profunda. A solidão me consumia, mesmo cercada de pessoas. Através dos exercícios de PNL e das cartas, aprendi que o problema não era as outras pessoas — era como eu me apresentava ao mundo, com muros altíssimos. Hoje tenho um grupo de amigas incrível, um namorado que me ama de verdade, e finalmente sei o que é pertencer a algum lugar.",
    fraseDestaque: "Aprendi a derrubar os muros e criar conexões verdadeiras",
    estrelas: 5,
    curtidas: 318,
    dataPublicacao: "2024-04-20"
  },
  {
    id: 15,
    nome: "Eduardo Castro",
    cidade: "Belo Horizonte, MG",
    email: "edu.castro@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20mature%20confident%20brazilian%20man%20in%20his%20late%20thirties%20with%20beard%20natural%20smile%20creative%20office%20environment%20warm%20authentic%20modern%20photography&width=400&height=400&seq=dep-edu-castro&orientation=squarish",
    categoria: "Carreira",
    tipoTransformacao: "Empreendedorismo",
    tempoUsando: "7 meses",
    depoimento: "Sonhava em empreender há 10 anos, mas o medo do fracasso me paralisava completamente. Toda vez que chegava perto de dar o passo, minha mente sabotava. Descobri que carregava uma crença de que 'pessoas da minha família não têm sucesso nos negócios'. Usando a técnica de ressignificação da Bia, trabalhei essa crença em profundidade. Sete meses depois, abri minha agência de design. Faturamos R$ 120k no primeiro semestre. Era possível o tempo todo — eu que não acreditava.",
    fraseDestaque: "Era possível o tempo todo — eu que não acreditava",
    estrelas: 5,
    curtidas: 445,
    dataPublicacao: "2024-05-03"
  },
  {
    id: 16,
    nome: "Sofia Andrade",
    cidade: "Vitória, ES",
    email: "sofia.andrade@example.com",
    foto: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20beautiful%20brazilian%20woman%20in%20her%20twenties%20glowing%20healthy%20skin%20radiant%20natural%20smile%20outdoor%20park%20background%20warm%20golden%20light%20authentic%20lifestyle%20photography&width=400&height=400&seq=dep-sofia-saude&orientation=squarish",
    categoria: "Saúde",
    tipoTransformacao: "Bem-estar Físico",
    tempoUsando: "6 meses",
    depoimento: "Lutava com compulsão alimentar e uma relação muito conturbada com meu corpo há quase uma década. Já tentei dieta, reeducação alimentar, academia — tudo funcionava por um tempo e depois parava. Com a Bia, entendi que o problema estava na minha mente, não no meu prato. As técnicas de ancoragem e o caderno de gratidão me deram ferramentas para lidar com a ansiedade que gerava os episódios. Hoje estou 12kg mais leve, mas principalmente: estou em paz comigo mesma.",
    fraseDestaque: "Estou 12kg mais leve, mas principalmente: estou em paz comigo mesma",
    estrelas: 5,
    curtidas: 531,
    dataPublicacao: "2024-05-15"
  }
];
